import { useMemo } from 'react';

import { useAddonsLlmKeys } from '@newfold/huapi-js';

import { mapLlmApiKey } from '../utils/helpers';

const useLlmApiKeys = (addonId?: string, enabled = false) => {
  const {
    data: keysData,
    isPending,
    isError,
    isFetching,
    refetch,
  } = useAddonsLlmKeys(addonId ?? '', undefined, {
    query: {
      enabled: enabled && !!addonId,
      select: (response) => ({
        keys: response?.data?.keys ?? [],
        inferenceBaseUrl: response?.data?.inference_base_url ?? '',
      }),
    },
  });

  const apiKeys = useMemo(
    () => (keysData?.keys ?? []).map(mapLlmApiKey),
    [keysData?.keys],
  );
  const gatewayEndpoint = keysData?.inferenceBaseUrl ?? '';

  return {
    apiKeys,
    gatewayEndpoint,
    isPending,
    isError,
    isFetching,
    refetch,
  };
};

export default useLlmApiKeys;
